///////index.js 



// import React from "react";
// import ReactDOM from "react-dom/client";
// import "./index.css";
// import App from "./App";
// import { BrowserRouter, Route, Routes } from "react-router-dom";
// import 'bootstrap/dist/css/bootstrap.min.css';

// const root = ReactDOM.createRoot(document.getElementById("root"));
// root.render(
//   <BrowserRouter>
//     <Routes>
//       <Route path="*" element={<App />}></Route>
//     </Routes>
//   </BrowserRouter>
// );

// // If you want to start measuring performance in your app, pass a function
// // to log results (for example: reportWebVitals(console.log))
// // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// // reportWebVitals();


// public/index.js
// import React from "react";
// import ReactDOM from "react-dom/client";
// import "./index.css";
// import App from "./App";
// import { BrowserRouter, Route, Routes } from "react-router-dom";
// import 'bootstrap/dist/css/bootstrap.min.css';

// // Redirect before React renders
// const hostname = window.location.hostname;
// if (hostname.includes(".recallalarms.com")) {
//   const newHostname = hostname.replace("lostnfound.recallalarms.com", "lostnfounds.com");
//   const newUrl = `${window.location.protocol}//${newHostname}${window.location.pathname}${window.location.search}`;
//   window.location.replace(newUrl);
// } else {
//   const root = ReactDOM.createRoot(document.getElementById("root"));
//   root.render(
//     <React.StrictMode>
//       <BrowserRouter>
//         <Routes>
//           <Route path="*" element={<App />} />
//         </Routes>
//       </BrowserRouter>
//     </React.StrictMode>
//   );
// }


// src/index.js
const hostname = window.location.hostname;
if (hostname.includes(".recallalarms.com")) {
  const newHostname = hostname.replace("lostnfound.recallalarms.com", "lostnfounds.com");
  const newUrl = `${window.location.protocol}//${newHostname}${window.location.pathname}${window.location.search}`;
  window.location.replace(newUrl);
} else {
  // Only import React and render if NOT redirecting
  import("./main");
}
